/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Viewings_Report_AttendedInputs */

const cs_viewings_report_attended = /** @type {(inputs: Viewings_Report_AttendedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Účast: ${i?.n}`)
};

const en_viewings_report_attended = /** @type {(inputs: Viewings_Report_AttendedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Attended: ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Attended: {n}" |
*
* @param {Viewings_Report_AttendedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const viewings_report_attended = /** @type {((inputs: Viewings_Report_AttendedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewings_Report_AttendedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewings_report_attended(inputs)
	return cs_viewings_report_attended(inputs)
});